import { render, staticRenderFns } from "./StationAdmin.vue?vue&type=template&id=63f89fc4&scoped=true&"
import script from "./StationAdmin.vue?vue&type=script&lang=js&"
export * from "./StationAdmin.vue?vue&type=script&lang=js&"
import style0 from "./StationAdmin.vue?vue&type=style&index=0&id=63f89fc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f89fc4",
  null
  
)

export default component.exports